export function cloneClassInstance<T extends object>(instance: T, updates?: Partial<T>): T {
	return Object.assign(Object.create(Object.getPrototypeOf(instance) as object), instance, updates) as T;
}

export function isSubclassOf(subclass: any, parentClass: any): boolean {
	// Walk up the prototype chain to check for inheritance
	while (subclass) {
		if (subclass === parentClass) return true;
		subclass = Object.getPrototypeOf(subclass);
	}
	return false;
}

export const filter = (obj: object, predicate: (obj : any) => any[]) => {
	const result = {};
	let key;

	for (key in obj) {
		if (Object.prototype.hasOwnProperty.call(obj, key) && predicate((obj as any)[key])) {
			(result as any)[key] = (obj as any)[key];
		}
	}

	return result;
};

export function shallowEqual<T extends object>(obj1: T, obj2: T, ignoreKeys: (keyof T)[] = []): boolean {
	const keys1 = Object.keys(obj1).filter((k) => !ignoreKeys.includes(k as keyof T));
	const keys2 = Object.keys(obj2).filter((k) => !ignoreKeys.includes(k as keyof T));

	if (keys1.length !== keys2.length) return false;
	return keys1.every((key) => obj1[key as keyof T] === obj2[key as keyof T]);
}

export function parseBooleanStrict(value: string) {
	if (value === "true") return true;
	if (value === "false") return false;
	throw new Error(`Invalid boolean string: ${value}`);
}

export function extractDefinedFields<T extends object, K extends keyof T>(source: Partial<Pick<T, K>>, keys: readonly K[]): Partial<Pick<T, K>> {
	const result = {} as Partial<Pick<T, K>>;
	for (const key of keys) {
		if (source[key] !== undefined) {
			result[key] = source[key]!;
		}
	}
	return result;
}
